// extracted by mini-css-extract-plugin
module.exports = {"header":"infoBus_header__2WXgr","chofer":"infoBus_chofer__2Htis","configuration":"infoBus_configuration__9pW_y"};